<template>
  <div class="card card-xs-full">
    <div class="card-body pb-0">
      <div class="d-flex align-items-center mb-2">
        <h5 class="mb-0">{{ title }}</h5>
        <button
          v-if="title === 'Total Power Consumption – kWh'"
          class="btn btn-sm ms-auto"
          :class="themeMode === 'dark' ? 'btn-outline-light' : 'btn-outline-secondary'"
          @click="$emit('downloadTotalsCsv')"
        >
          <i class="fa fa-file-csv me-1" /> CSV
        </button>
      </div>

      <div class="row gx-2">
        <div class="col">
          <apex-chart :key="chartKey" width="100%" type="bar" :options="graphOptions" :series="series"></apex-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import ApexChart from 'vue-apexcharts'

export default {
  components: {
    ApexChart
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    graphOptions: {
      default: []
    },
    series: {
      type: Array
    },
    chartKey: {
      type: String,
      default: ''
    }
  },
  computed: {
    themeMode: get('theme/mode'),
  }
}
</script>
